/* unplugin-vue-components disabled */import { defineComponent, onMounted, ref } from "vue";
import APIHelper from "@/api/APIHelper";
import { ElCarousel, ElCarouselItem } from "element-plus";
import 'element-plus/es/components/carousel/style/css'
import 'element-plus/es/components/carousel-item/style/css'

import { baseUrl } from "@/Global";
import LogoIcon from "@/components/LogoIcon.vue";
//import NewsComponent from "@/components/common/NewsComponent.vue";
import IconList from "@/components/common/IconList.vue";
export default defineComponent({
  name: "HomeView",
  components: {
    ElCarousel,
    ElCarouselItem,
    LogoIcon,
    //NewsComponent,
    IconList
  },
  setup(props, ctx) {
    const productData = ref([{
      title: "SHOWER HOSE BY BGC (0.8m~2.5m)",
      des: ["304 stainless steel double-buckle tube.", "Length 0.8m to 2.5m.", "Both ends of the diameter can be a variety of collocation (eg.G1/2&1/2-14NPSM).", "You can choose PVC/TPE/EPDM/PEX/TPV.", "Materials can be customized."],
      img: "20170824083345496.jpg"
    }]);
    const carouselImgs = ref([{
      url: "carousel0.png",
      position: "left top"
    }, {
      url: "carousel1.png",
      position: "right top"
    }, {
      url: "carousel0.png",
      position: "left top"
    }]);
    const currentIndex = ref(0);
    //const baseUrl=process.env.VUE_APP_BASE_URL
    //热销产品
    const bestSells = ref([]);
    //产品分类
    const productClass = ref([]);
    //荣誉证书
    const honors = ref([]);
    //新闻
    const news = ref([]);
    onMounted(() => {
      APIHelper.getInstance().getJson(baseUrl + "json/home_product_list.json").then(res => {
        console.log(res);
        productData.value = res.list;
      });
      //荣誉证书
      APIHelper.getInstance().getJson(baseUrl + "json/honor.json").then(res => {
        console.log(res);
        honors.value = res.scenes.list.slice(2, 6);
      });
      //
      /*APIHelper.getInstance().getJson(baseUrl+'json/best_sellers.json').then((res)=>{
        console.log(res)
        bestSells.value=res
      })*/
      //加载home.json
      APIHelper.getInstance().getJson(baseUrl + "json/home.json").then(res => {
        console.log(res);
        productClass.value = res.class;
        bestSells.value = res.bestSellers;
        news.value = res.news;
      });
      //
      setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % carouselImgs.value.length;
      }, 6000);
    });
    return {
      currentIndex,
      productData,
      carouselImgs,
      bestSells,
      baseUrl,
      productClass,
      honors,
      news
    };
  }
});